const goToTop = () => {
  const rcRoot = document.getElementById('rcroot');
  rcRoot.scrollIntoView();
};

export default goToTop;
